<script lang="ts">
	import { page } from '$app/state'
	import { signOut } from '$lib/authentication/firebase'
	import authState from '$lib/stores/auth-state'
	import modal from '$lib/stores/modal-state'
	import AccountMenu from './AccountMenu.svelte'
	import Button from '../buttons/Button.svelte'
	import MenuIcon from '../icons/MenuIcon.svelte'
	import { track } from '$lib/utils/track'
	import { stopPropagation } from '$lib/utils/clickHelpers'
	import Avatar from '$components/profiles/Avatar.svelte'

	interface Props {
		onopen?: (navType: NavType) => void
		onstartTrip?: () => void
	}

	let { onopen, onstartTrip }: Props = $props()

	let layoutType = $derived(page.data.layoutType)

	let signedIn = $derived($authState.signedIn)

	function handleStartTrip() {
		onstartTrip?.()
	}

	function handleShowLoginClick() {
		track('Sign In Clicked')
		modal.open('signup', { intent: 'signIn' })
	}

	function handleClickOnMobile() {
		track('Mobile Menu Clicked')
		onopen?.('mobile')
	}

	function handleSignOut() {
		track('Sign Out Clicked')
		signOut()
	}

	let avatarSrc = $derived(
		$authState.currentUser?.currentProfilePictureUrl &&
			$authState.currentUser.currentProfilePictureUrl != ''
			? $authState.currentUser.currentProfilePictureUrl
			: '/visuals/icons/default-user.svg',
	)

	let name = $derived($authState.currentUser?.currentName || '')
</script>

<nav
	class={`fixed mx-auto top-0 mb-[2px] left-0 right-0 ${
		layoutType === 'itinerary' || layoutType === 'profile'
			? 'bg-transparent lg:hidden'
			: 'bg-white shadow-sm'
	} z-40 flex flex-col items-center justify-center`}
>
	<div class="max-w-screen-xl flex items-stretch justify-between h-16 px-2 lg:px-8 2xl:px-6 w-full">
		<div class="flex px-0 lg:px-0 items-center flex-shrink-0 lg:pr-6">
			{#if layoutType === 'itinerary'}
				<a href="/" class="items-center leading-none hidden lg:flex">
					<img src="/airheart-logo-full-new.svg" height={40} width={148} alt="Airheart Logo" />
				</a>
			{:else if layoutType !== 'profile'}
				<a href="/" class="flex items-center leading-none">
					<img src="/airheart-logo-full-new.svg" height={40} width={148} alt="Airheart Logo" />
				</a>
			{/if}
		</div>

		<div class="hidden lg:flex">
			<a
				href="/guide"
				class="linkUnderline flex items-center justify-center w-36 pt-2 text-base font-normal tracking-tight text-center text-black px-auto"
			>
				Sell Your Guides
			</a>
			{#if signedIn}
				<a
					href="/trips"
					class="linkUnderline flex items-center justify-center w-36 pt-2 text-base font-normal tracking-tight text-center text-black px-auto"
				>
					Your Trips
				</a>
			{/if}

			<a
				href="/explore"
				class="linkUnderline flex items-center justify-center w-36 pt-2 text-base font-normal tracking-tight text-center text-black px-auto"
			>
				Explore Guides
			</a>
		</div>

		<div class="flex items-center justify-end space-x-2 flex-1 w-full">
			<div
				class={`flex items-center ${
					layoutType === 'itinerary' || layoutType === 'profile'
						? 'p-3 lg:p-0 bg-white dark:bg-brand-gray-5 lg:bg-transparent rounded-full lg:rounded-none shadow-lg lg:shadow-none'
						: 'ml-2'
				} lg:hidden `}
			>
				<button
					aria-label="Open Menu"
					type="button"
					class={`inline-flex items-center text-base font-medium whitespace-nowrap focus:outline-none focus:ring-transparent focus:ring-offset-0 touch-manipulation ${
						layoutType === 'itinerary' || layoutType === 'profile'
							? 'dark:text-brand-gray-0 hover:text-white'
							: 'text-black hover:text-brand-gray-5 border border-brand-gray-3 rounded-full p-1'
					}`}
					onclick={stopPropagation(handleClickOnMobile)}
				>
					<span class="sr-only">Open sidebar</span>
					<!-- <span class="hidden mr-3 sm:flex">Menu</span> -->

					<MenuIcon class={`h-6 w-6 `} />
					{#if signedIn}
						<Avatar size="sm" src={avatarSrc} alt={name} hoverable={false} />
					{/if}
				</button>
			</div>
			<div class="items-center hidden space-x-4 lg:flex">
				<Button theme="dark" size="sm" onclick={handleStartTrip}>Start Your Trip</Button>
				{#if signedIn}
					<AccountMenu
						class="relative flex-shrink-0"
						user={$authState.currentUser}
						onsignout={handleSignOut}
						embedded={false}
					/>
				{:else}
					<button
						id="sign-in"
						aria-label="Sign in"
						onclick={stopPropagation(handleShowLoginClick)}
						class="text-md font-medium text-black whitespace-nowrap hover:text-gray-800 focus:outline-none touch-manipulation"
					>
						Sign in
					</button>
				{/if}
			</div>
		</div>
	</div>
</nav>
